// extracted by mini-css-extract-plugin
module.exports = {"buttonXxsSecondaryDanger":"ButtonXxsSecondaryDanger_buttonXxsSecondaryDanger__31TYI"};